import styled from "styled-components";

export const ContainerDiv = styled.div`
  display: grid;
  gap: 10%;
  grid-template-columns: 1fr 1fr;
  margin-top: 6rem;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 0 10%;
  }

  & .leftSide {
    padding-left: 15%;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;

    @media screen and (max-width: 768px) {
      padding: 0;
    }
  }

  & .rightSide {
    display: flex;
    justify-content: center;
  }
`;
